<template>
  <v-container style="max-width: 800px;">
    <v-card elevation="4" class="pa-6">
      <div class="header-center">
      <v-img
        src="favicon-32x32.png"
        max-width="120"
        class="mx-auto mb-4"
      ></v-img>

      <h2>PC‑Client herunterladen</h2>
      <p>
        Lade den aktuellen Windows‑Client herunter und installiere ihn auf deinem Computer.
      </p>

      <form
  :action="`${backendUrl}loadSetup`"
  method="POST"
  ref="downloadForm"
  style="display: none;"
>
  <input type="hidden" name="beta" :value="betaValue" />
</form>

<v-btn
  color="primary"
  large
  @click="submitDownload"
>
  <v-icon left>mdi-download</v-icon>
  Download ThoFu_Bot_Connect_Setup.exe
</v-btn>

      <p class="mt-4 grey--text" v-if="version">
        Version {{ version }} • Letztes Update: {{ updated }}
      </p>
      </div>

      <v-divider class="my-6"></v-divider>

      <h3>Changelog</h3>
      <div v-html="changelog" class="markdown-body"></div>
    </v-card>
  </v-container>
</template>

<script>
import BackendService from '@/services/BackendService';
import { marked } from 'marked';

export default {
  data() {
    return {
      version: null,
      updated: null,
      backendUrl: process.env.VUE_APP_BACKENDSERVICE_BASEURL,
      changelog: '',
      betaValue: null,
    };
  },

  mounted() {
    const isBeta = window.location.hostname.includes('beta.thofubot.de');
    this.betaValue = isBeta ? 1 : 0; // <-- WICHTIG!

    BackendService.loadSetupVersion({ beta: this.betaValue }).then((res) => {
      this.version = res.data.version;
      this.updated = res.data.updated;
    });

    BackendService.loadChangelog({ beta: this.betaValue }).then((res) => {
      this.changelog = marked(res.data);
    });
  },

  methods: {
    submitDownload() {
      // Sicherheit: Vue DOM-Update abwarten
      this.$nextTick(() => {
        this.$refs.downloadForm.submit();
      });
    },
  },
};
</script>

<style>
.header-center {
  text-align: center;
}

.markdown-body {
  text-align: left !important;
  white-space: normal !important;
  overflow: visible !important;
  line-height: 1.6;
}

.markdown-body h1,
.markdown-body h2,
.markdown-body h3 {
  margin-top: 24px;
  font-weight: 600;
}

.markdown-body ul {
  padding-left: 20px;
  list-style: disc;
}

.markdown-body hr {
  margin: 24px 0;
}
</style>
